let chart = {
  option : {
    title : {
        show: false,            
        x:'center'
    },
    tooltip : {
        trigger: 'item',
        formatter: "{b} : {c} ({d}%)"
    },
    legend: {
        orient: 'vertical',            
        x: 'left',
        data: ['Jokowi-Amin','Prabowo-Sandi']
    },
    toolbox: {
        show : true,
        x: 'right',
        feature : {
            mark : {show: true},
            //dataView : {show: true, readOnly: false},
            //restore : {show: true},
            saveAsImage : {show: true, title:'Pict'}
        }
    },
    series : [
        {
            name: 'pilpres',
            type: 'pie',
            radius : '90%',
            center: ['50%', '50%'],
            data:[
                {value:335, name:'Jokowi-Amin',  itemStyle: {color: 'red'},},
                {value:370, name:'Prabowo-Sandi',itemStyle: {color: 'blue'},},                    
            ],
            itemStyle : {
                normal : {
                    label : {
                        position : 'inner',
                        formatter : "{d}%\n\n{c}",
                        /*formatter : function (params) {                         
                          return (params.percent - 0).toFixed(0) + '%'
                        }*/
                        textStyle : {}
                    },
                    labelLine : {
                        show : true
                    }
                },
                emphasis : {
                    label : {
                        show : true,
                        formatter : "{d}%\n\n{c}"
                    }
                }

            },
        }
    ],    
  }   
}; 

export default chart;

